import React, { useState, useEffect } from 'react'
import './Popular.css'
// import popular_data from '../Assets/popular_data'
import Item from '../Item/Item'

const Popular = () => {

  const [popular_products, setPopular_products] = useState([]);

  useEffect(()=>{
    fetch(`${process.env.REACT_APP_API_URL}/popular-products`)
    .then((response)=>response.json())
    .then((data)=>setPopular_products(data));
  },[]);

  return (
    <div className='popular'>
        <h2>Popular Products</h2>
        <div className="popular-items">
            {popular_products.map((item, index)=>{
                return <Item key={index} id={item.id} name={item.name} discount_percentage={item.discount_percentage} available={item.available} image={item.images[0]} price={item.price} old_price={item.old_price}/>;
            })}
        </div>
    </div>
  )
}

export default Popular